<template>
  <div class="background">
    <svg class="title-text" viewBox="0 0 162.5 24">
      <text class="title" x="81.25" y="15" font-size="14" text-anchor="middle">
        Infusion Marker
      </text>
    </svg>
    <div class="buttons">
      <button class="up-button" @click="upButtonClick"></button>
      <button class="down-button" @click="downButtonClick"></button>
      <button class="off-button" @click="offButtonClick"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfusionButtons',
  methods: {
    upButtonClick() {
      this.$emit('add-infusion-up-marker')
    },
    downButtonClick() {
      this.$emit('add-infusion-down-marker')
    },
    offButtonClick() {
      this.$emit('add-infusion-off-marker')
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.background {
  display: grid;
  grid-template-rows: 25% 75%;
  grid-template-columns: 100%;
}
svg {
  width: 100%;
}
.title-text {
  grid-row: 1;
  font-family: 'Segoe UI';
  fill: #00413b;
}
.buttons {
  grid-row: 2;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.up-button {
  grid-column: 1;
  background-color: transparent;
  background-image: url('../assets/up-iv.svg');
  background-repeat: no-repeat;
  background-position: center;
  margin-right: -10%;
  margin-left: 10%;
  background-size: 100%;
  border: none;
}
.down-button {
  grid-column: 2;
  margin-left: -13%;
  margin-right: 13%;
  background-color: transparent;
  background-image: url('../assets/down-iv.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  border: none;
}

.off-button {
  grid-column: 3;
  background-color: transparent;
  background-image: url('../assets/off-iv.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  margin-left: -7%;
  margin-right: 7%;
  border: none;
}
button:focus {
  outline: none;
}
</style>
